import { formatNumber } from '@angular/common';
import { Pipe } from '@angular/core';
import { BloodGlucoseUnit } from '@libs/shared/interfaces/couch/models/user';
import { UserQuery } from '@libs/shared/interfaces/couch/queries/user';

import { ReactiveLocalePipeBase } from './reactive-locale-pipe.base';

const MG_PER_DL_TO_MMOL_PER_L = 0.0555;

@Pipe({
  name: 'bloodGlucose',
  standalone: false,
  pure: false,
})
export class BloodGlucosePipe extends ReactiveLocalePipeBase {
  constructor(private readonly userQuery: UserQuery) {
    super();
  }

  transform(valueMgdl: null | undefined | number, unit?: BloodGlucoseUnit, format = '1.0-1'): string | null {
    if (!valueMgdl) {
      return null;
    }

    unit = unit ?? this.userQuery.getBloodGlucoseUnit();

    const transformedValue = unit === 'MG_DL' ? valueMgdl : valueMgdl * MG_PER_DL_TO_MMOL_PER_L;

    return formatNumber(transformedValue, this.locale, format);
  }

  getUnit(): BloodGlucoseUnit {
    return this.userQuery.getBloodGlucoseUnit();
  }

  convertToMgDl(valueMmolPerL: number): number {
    return valueMmolPerL / MG_PER_DL_TO_MMOL_PER_L;
  }
}
